(() => {
  const ROOT = "#judgeme_product_reviews";
  const INSERTED_CLASS = "jm-inline-rating-star";
  const CLAMP_LINES = "5";
  const CLAMP_SELECTOR = ".jdgm-carousel-item__review-body.jdgm-line-clamp, .jm-carousel-item__review-body";
  const TITLE_SELECTOR = ".jdgm-carousel-item__product-title, .jm-carousel-item__product-title";

  function applyReviewClamp() {
    const reviewBodies = document.querySelectorAll(CLAMP_SELECTOR);
    reviewBodies.forEach((el) => {
      el.style.setProperty("line-height", "1.15", "important");
      el.style.setProperty("max-height", "calc(1.15em * 5)", "important");
      el.style.setProperty("overflow", "hidden", "important");

      const textNode = el.querySelector("p") || el;
      textNode.style.setProperty("display", "-webkit-box", "important");
      textNode.style.setProperty("-webkit-box-orient", "vertical", "important");
      textNode.style.setProperty("-webkit-line-clamp", CLAMP_LINES, "important");
      textNode.style.setProperty("line-height", "1.15", "important");
      textNode.style.setProperty("overflow", "hidden", "important");
      textNode.style.setProperty("margin", "0", "important");
    });
  }

  function applyTitleWrap() {
    const titles = document.querySelectorAll(TITLE_SELECTOR);
    titles.forEach((el) => {
      el.classList.remove("jdgm-ellipsis", "jm-ellipsis");
      el.style.setProperty("white-space", "normal", "important");
      el.style.setProperty("overflow", "hidden", "important");
      el.style.setProperty("text-overflow", "clip", "important");
      el.style.setProperty("display", "-webkit-box", "important");
      el.style.setProperty("-webkit-box-orient", "vertical", "important");
      el.style.setProperty("-webkit-line-clamp", "3", "important");
      el.style.setProperty("line-clamp", "3", "important");
      el.style.setProperty("line-height", "1.2", "important");
      el.style.setProperty("max-height", "calc(1.2em * 3)", "important");
      el.style.setProperty("overflow-wrap", "anywhere", "important");
      el.style.setProperty("word-break", "break-word", "important");
    });
  }

  function applyCarouselTextTweaks() {
    applyReviewClamp();
    applyTitleWrap();
  }

  function addStar() {
    const root = document.querySelector(ROOT);
    if (!root) return false;

    const headerCluster = root.querySelector(
      ".jm-average-rating-display--minimal-header .jm-cluster"
    );
    if (!headerCluster) return false;

    const ps = headerCluster.querySelectorAll("p.jm-text");
    if (ps.length < 2) return false;

    const reviewsEl = ps[1];

    if (headerCluster.querySelector(`.${INSERTED_CLASS}`)) return true;

    const templateStar =
      root.querySelector(`.jm-review-item__body .jm-star-rating__font-icon`) ||
      root.querySelector(`.jm-star-rating__font-icon`);

    if (!templateStar) return false;

    const star = templateStar.cloneNode(true);
    star.classList.add(INSERTED_CLASS);
    star.setAttribute("aria-hidden", "true");

    star.removeAttribute("style");
    star.style.fontSize = "1em";
    star.style.lineHeight = "1";
    star.style.marginLeft = "0.2em";
    star.style.marginRight = "0.35em";
    star.style.position = "relative";
    star.style.top = "0.02em";
    star.style.color = "var(--jm-review-widget-star-and-histogram-color)";

    headerCluster.insertBefore(star, reviewsEl);
    return true;
  }

  function runWithRetries() {
    let tries = 0;
    const maxTries = 60;
    const t = setInterval(() => {
      tries += 1;
      applyCarouselTextTweaks();
      if (addStar() || tries >= maxTries) clearInterval(t);
    }, 250);
  }

  function observeCarouselUpdates() {
    const root = document.body;
    if (!root) return;

    const observer = new MutationObserver(() => {
      applyCarouselTextTweaks();
    });
    observer.observe(root, { childList: true, subtree: true });
    applyCarouselTextTweaks();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      runWithRetries();
      observeCarouselUpdates();
    });
  } else {
    runWithRetries();
    observeCarouselUpdates();
  }

  document.addEventListener("shopify:section:load", () => {
    runWithRetries();
    applyCarouselTextTweaks();
  });
})();
